import React from 'react';
import { NavLink } from 'react-router-dom';
import { Icon } from '@vectord/components';

import styles from './CreatePlaylistButton.module.scss';

function CreatePlaylistButton() {
  return (
    <NavLink
      className={styles.root}
      to="playlist"
      target="_blank"
      rel="noopener noreferrer"
    >
      Ingest New Playlist
      <Icon
        name="add"
        className="m-l-xs"
      />
    </NavLink>
  );
}

export default CreatePlaylistButton;
